<div class="lds-css">
  <div class="lds-hourglass"></div>
</div>
